import { Signal, createEffect, createRoot, createSignal } from 'solid-js';
import { UserFilterGroupInfo } from 'st-app/api';

export class UserFilterGroupInstance extends UserFilterGroupInfo {
    name: Signal<string>;
    isDropTarget = createSignal(false);
    isDragging = createSignal(false);

    constructor(data: UserFilterGroupInfo) {
        super();
        Object.assign(this, data);

        this.name = createSignal(data.groupName || '');

        createRoot(() => {
            createEffect(() => this.groupName = this.name[0]());
        });
    }
}
